import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import InstagramProfile from "../InfoModal/InstagramProfile";

export default function InfluencerModal({ open, handleClose, handles = [], city = "" }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    if (!handles.length) return null;

    return (
        <Dialog open={open} onClose={handleClose} fullScreen={fullScreen}>
            <DialogTitle>
                <Typography variant="h6">{city}</Typography>
                <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Container>
                    {handles.map((handle) => (
                        <InstagramProfile key={handle} profileTag={handle} />
                    ))}
                </Container>
            </DialogContent>
        </Dialog>
    );
} 